/* src/app/shared/components/dialogs/unauthorized/unauthorized.component.scss */
p {
  width: 100%;
  text-align: center;
  margin-top: 64px;
}
/*# sourceMappingURL=unauthorized.component-U2PTJRML.css.map */
